<template>
  <div id="bto-design-customize-panel">
    <slot name="design-customize-size"></slot>
    <slot name="design-customize-select"></slot>
    <slot name="design-customize-parts"></slot>
  </div>
</template>

<script>
export default {
  name: "PanelDesignCustomize",
};
</script>

<style scoped lang="stylus">
@css {
  #bto-design-customize-panel {
    @apply text-sm
  }
  #bto-design-customize-panel h2 {
    color: #5f402a;
    @apply font-bold text-base
  }
}
</style>
